import { render, staticRenderFns } from "./AdminCreateCity.vue?vue&type=template&id=bb678f22&scoped=true&"
import script from "./AdminCreateCity.vue?vue&type=script&lang=js&"
export * from "./AdminCreateCity.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreateCity.vue?vue&type=style&index=0&id=bb678f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb678f22",
  null
  
)

export default component.exports